import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAPI } from "../api/useAPI";
import { useBehaviorSubjectState } from "./useBehaviorSubjectState";

interface AuthGuardProps {
  children: any;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const api = useAPI();
  const [isLoggedIn] = useBehaviorSubjectState(api.isLoggedIn$);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  if (!isLoggedIn) {
    return null;
  }

  return <>{children}</>;
};
